import dropdownStateSelector from '../dropdown-state/dropdownStateSelector';
import { insuranceTypeSelector } from '../insurance-type';
import { TAB } from '../../constants';

function getInsuranceType(state) {
    const insuranceTypeId = insuranceTypeSelector(state);
    switch (insuranceTypeId) {
        case 1:
            return 'dental';
        case 3:
            return 'vision';
        default:
            return 'health';
    }
}

export function getTypedValue(state) {
    const dropdownState = dropdownStateSelector(state);
    return dropdownState.typedValue;
}

export function getDirectoryId(state) {
    const dropdownState = dropdownStateSelector(state);
    return dropdownState.directoryId || '-1';
}

export function isPlanRequest(dropdownState) {
    return dropdownState.tab !== TAB.INSURANCE && dropdownState.carrier;
}

export function getApiUrl(getState, searchQuerySequence, sessionId, trackingId) {
    const state = getState();
    const insuranceType = getInsuranceType(state);
    const directoryId = getDirectoryId(state);
    const dropdownState = dropdownStateSelector(state);
    const API_URL = process.env.AWS_API_HOST || dropdownState.AWS_API_HOST || '';
    const { tracking } = dropdownState;
    const text = dropdownState.typedValue || '-empty-';

    const sessionIdQueryString = sessionId ? `&session_id=${sessionId}` : '';
    const trackingIdQueryString = trackingId ? `&tracking_id=${trackingId}` : '';

    let url = `${API_URL}/directory/v1/insurances/autocomplete?text=${text}&insurance_type=${insuranceType}&directory_id=${directoryId}`
        + `${sessionIdQueryString}${trackingIdQueryString}&search_query_sequence=${searchQuerySequence}`;

    if (isPlanRequest(dropdownState)) {
        url += `&carrier_id=${dropdownState.carrier.id}`;
    }

    if (tracking && typeof tracking === 'object') {
        try {
            tracking.carrier = dropdownState.carrier;
            tracking.searchQuerySequence = searchQuerySequence;
            const serializedTracking = JSON.stringify(tracking);
            url += `&tracking=${serializedTracking}`;
        } catch (e) {
            // swallow
        }
    }

    return url;
}
